import { render, staticRenderFns } from "./CooperationCases.vue?vue&type=template&id=3ddb3744&scoped=true"
import script from "./CooperationCases.vue?vue&type=script&lang=js"
export * from "./CooperationCases.vue?vue&type=script&lang=js"
import style0 from "./CooperationCases.vue?vue&type=style&index=0&id=3ddb3744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddb3744",
  null
  
)

export default component.exports